export function listGames() {
  return [
    {
      key: 'dice',
      name: 'Dice',
      summary: 'Players roll a die; highest total wins.',
      icon: '🎲',
      rules: [
        'Each player rolls a standard 6-sided die per round.',
        'Highest total after all rounds wins.'
      ],
      config: {
        Number_of_rounds: { type: 'number', min: 1, max: 10, default: 5 },
      },
      defaults: { Number_of_rounds: 5 },
    },
    {
      key: 'cards',
      name: 'High Card Draw',
      summary: 'Draw a card; highest card wins.',
      icon: '🃏',
      rules: [
        'Each player draws a card each round.',
        'Highest card wins the round; most rounds wins the game.'
      ],
      config: {
        Number_of_rounds: { type: 'number', min: 1, max: 10, default: 5 },
      },
      defaults: { Number_of_rounds: 5 },
    },
  ];
}
